import { render, staticRenderFns } from "./diywindow.vue?vue&type=template&id=fadf70e4&scoped=true&"
import script from "./diywindow.vue?vue&type=script&lang=js&"
export * from "./diywindow.vue?vue&type=script&lang=js&"
import style0 from "./diywindow.vue?vue&type=style&index=0&id=fadf70e4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fadf70e4",
  null
  
)

export default component.exports